import styled, { css } from 'styled-components';

import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';

export const Wrapper = styled.div<{ marginRight: number; marginLeft: number; $hiddenXs: boolean }>`
  margin-right: ${props => props.marginRight}px;
  margin-left: ${props => props.marginLeft}px;  
  ${props =>
    props.$hiddenXs
      ? css`
          ${props => props.theme.breakpoints.down('sm')} {
            display: none;
          }
        `
      : null}
`;

const StyledDiv = styled.div<{ hasBorder: boolean }>`
  display: flex;
  align-items: center;
  ${props => props.hasBorder && `border:2px solid rgba(255,255,255,0.9);`};  
  border-radius: 50%;
  overflow: hidden;
`;

const StyledImage = styled.img<{}>`
  width: 100%;
  height: 100%;
  object-fit: cover; 
  padding: 0px !important;
  margin: 0px !important;
`;

interface Props {
  image?: string;
  size?: number;
  hiddenXs?: boolean;
  marginRight?: number;
  marginLeft?: number;
  isLoading?: boolean;
  hasBorder?: boolean;
}

export const UserProfileIcon = ({
  image = '',
  size = 48,
  marginRight = 16,
  marginLeft = 0,
  hiddenXs = false,
  isLoading = false,
  hasBorder = false,
}: Props) => {
  return (
    <Wrapper $hiddenXs={hiddenXs} marginLeft={marginLeft} marginRight={marginRight}>
      <StyledDiv style={{ width: size, height: size }} hasBorder={hasBorder}>
        <LoadingSkeleton isLoading={isLoading} variant="circular" width={size} height={size}>
          <StyledImage src={image} />
        </LoadingSkeleton>
      </StyledDiv>
    </Wrapper>
  );
};
